<template>
    <v-container>
        <v-row>
            <v-col cols='12'>
                <v-card flat>
                    <v-card-title class='headline my-4'>Contributors</v-card-title>
                    <v-card-text>
                        <v-col cols='12' sm='12' lg='9' >
                            <p>
                                This platform has been brought to you by a talented team of designers, engineers,
                                technicians and digital types at <strong>Arup</strong>.
                            
                                If you'd like to get in touch, you can do so be emailing the
                                <v-chip outlined color='secondary' :href="`mailto:${email}`" >Carbon Insights Team</v-chip>
                            </p>
                        </v-col>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col
                cols='12'
                sm='12'
                md='6'
                lg='4'
            >
                <v-card
                    height='100%'
                >
                    <v-card-title>Development Team</v-card-title>
                    <v-card-actions>
                        <v-row class='mx-2'>
                            <v-col cols='12'>
                                <v-list
                                    two-line
                                    v-for='dev in developers'
                                    :key='dev.name'
                                >
                                    <v-list-item>
                                        <v-list-item-icon>
                                            <v-icon color='secondary'>mdi-account</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title>{{ dev.name }}</v-list-item-title>
                                            <v-list-item-subtitle>{{ dev.role }},<br>{{ dev.team }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-col>
                        </v-row>
                    </v-card-actions>
                </v-card>
            </v-col>
        
            <v-col
                cols='12'
                sm='12'
                md='6'
                lg='4'
            >
                <v-card
                    height='100%'
                >
                    <v-card-title>Structural Team</v-card-title>
                    <v-card-actions>
                        <v-row class='mx-2'>
                            <v-col cols='12'>
                                <v-list
                                    two-line
                                    v-for='pers in structures'
                                    :key='pers.name'
                                >
                                    <v-list-item>
                                        <v-list-item-icon>
                                            <v-icon color='secondary'>mdi-account</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title>{{ pers.name }}</v-list-item-title>
                                            <v-list-item-subtitle>{{ pers.role }},<br>{{ pers.team }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-col>
                        </v-row>
                    </v-card-actions>
                </v-card>
            </v-col>
            <v-col
                cols='12'
                sm='12'
                md='6'
                lg='4'
            >
                <v-card
                    height='100%'
                >
                    <v-card-title>Facades Team</v-card-title>
                    <v-card-actions class='mx-2'>
                        <v-row>
                            <v-col cols='12'>
                                <v-list
                                    two-line
                                    v-for='pers in facades'
                                    :key='pers.name'
                                >
                                    <v-list-item>
                                        <v-list-item-icon>
                                            <v-icon color='secondary'>mdi-account</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title>{{ pers.name }}</v-list-item-title>
                                            <v-list-item-subtitle>{{ pers.role }},<br>{{ pers.team }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-col>
                        </v-row>
                    </v-card-actions>
                </v-card>
            </v-col>
            <v-col
                cols='12'
                sm='12'
                md='6'
                lg='4'
            >
                <v-card
                    height='100%'
                >
                    <v-card-title>Mechanical Team</v-card-title>
                    <v-card-actions>
                        <v-row class='mx-2'>
                            <v-col cols='12'>
                                <v-list
                                    two-line
                                    v-for='pers in mechanical'
                                    :key='pers.name'
                                >
                                    <v-list-item>
                                        <v-list-item-icon>
                                            <v-icon color='secondary'>mdi-account</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title>{{ pers.name }}</v-list-item-title>
                                            <v-list-item-subtitle>{{ pers.role }},<br>{{ pers.team }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-col> 
                        </v-row>
                    </v-card-actions>
                </v-card>
            </v-col>
            <v-col
                cols='12'
                sm='12'
                md='6'
                lg='4'
            >
                <v-card
                    height='100%'
                >
                    <v-card-title>Civil Structures, Bridges and Tunnels (CSBT) Team</v-card-title>
                    <v-card-actions>
                        <v-row class='mx-2'>
                            <v-col cols='12'>
                                <v-list
                                    two-line
                                    v-for='pers in CSBT'
                                    :key='pers.name'
                                >
                                    <v-list-item>
                                        <v-list-item-icon>
                                            <v-icon color='secondary'>mdi-account</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title>{{ pers.name }}</v-list-item-title>
                                            <v-list-item-subtitle>{{ pers.role }},<br>{{ pers.team }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-col>
                        </v-row>
                    </v-card-actions>
                </v-card>
            </v-col>
            <v-col
                cols='12'
                sm='12'
                md='6'
                lg='4'
            >
                <v-card
                    height='100%'
                >
                    <v-card-title>Civil Engineering Team</v-card-title>
                    <v-card-actions>
                        <v-row class='mx-2'>
                            <v-col cols='12'>
                                <v-list
                                    two-line
                                    v-for='pers in civils'
                                    :key='pers.name'
                                >
                                    <v-list-item>
                                        <v-list-item-icon>
                                            <v-icon color='secondary'>mdi-account</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title>{{ pers.name }}</v-list-item-title>
                                            <v-list-item-subtitle>{{ pers.role }},<br>{{ pers.team }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-col>
                        </v-row>
                    </v-card-actions>
                </v-card>
            </v-col>
            <v-col
                cols='12'
                sm='12'
                md='6'
                lg='4'
            >
                <v-card
                    height='100%'
                >
                    <v-card-title>Maritime Team</v-card-title>
                    <v-card-actions>
                        <v-row class='mx-2'>
                            <v-col cols='12'>
                                <v-list
                                    two-line
                                    v-for='pers in maritime'
                                    :key='pers.name'
                                >
                                    <v-list-item>
                                        <v-list-item-icon>
                                            <v-icon color='secondary'>mdi-account</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title>{{ pers.name }}</v-list-item-title>
                                            <v-list-item-subtitle>{{ pers.role }},<br>{{ pers.team }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-col>
                        </v-row>
                    </v-card-actions>
                </v-card>
            </v-col>
            <v-col
                cols='12'
                sm='12'
                md='6'
                lg='4'
            >
                <v-card
                    height='100%'
                >
                    <v-card-title>Geotechnics Team</v-card-title>
                    <v-card-actions>
                        <v-row class='mx-2'>
                            <v-col cols='12'>
                                <v-list
                                    two-line
                                    v-for='pers in geotechnics'
                                    :key='pers.name'
                                >
                                    <v-list-item>
                                        <v-list-item-icon>
                                            <v-icon color='secondary'>mdi-account</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title>{{ pers.name }}</v-list-item-title>
                                            <v-list-item-subtitle>{{ pers.role }},<br>{{ pers.team }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-col>
                        </v-row>
                    </v-card-actions>
                </v-card>
            </v-col>
            
        </v-row>
        <v-row>
        </v-row>
    </v-container>
</template>

<script>
export default {
    data () {
        return {

            email: '6cf733ad.arup.onmicrosoft.com@emea.teams.ms',
            teamPage: 'https://teams.microsoft.com/l/team/19%3a0471aa82c51e4620b97fcd46f43c73a7%40thread.skype/conversations?groupId=c2a09e19-5bb1-4092-b04f-375df351b316&tenantId=4ae48b41-0137-4599-8661-fc641fe77bea',


            developers: [
                { name: "Tom Bunn", role: "Product Lead & front-end developer", team: "Building Engineering London" },
                { name: "Orlando Gibbons", role: "Sustainability advisor", team: "Building Engineering London" },
                { name: "Francesco Anselmo", role: "Back-end developer & database architect", team: "Smart Buildings London" },
                { name: "Gerasimos Kounadis", role: "Back-end developer", team: "Smart Buildings London" },
                { name: "Mitch Harvey", role: "Software development", team: "Melbourne Digital"},
                { name: "Jake Adkin", role: "Developer", team: "Building Engineering London" },
                { name: "Anna Kuncelman", role: "Developer", team: "Civil Struct Bridges Tunnels London" },
                { name: "Wojciech Markowski", role: "Developer", team: "Civil Struct Bridges Tunnels London" },
            ],

            structures: [
                { name: "Tara Clinton", role: "Lead structural engineer", team: "Building Engineering London" },
                { name: "Grace Di Benedetto", role: "Structural sustainability lead", team: "Building Engineering London" },
                { name: "Tom Styles" , role: "Structural technician", team: "Building Engineering London" },
                { name: "Will Arnold", role: "Structural review", team: "Buildings Engineering London" }
            ],

            facades: [
                { name: "Fernando Ruiz-Barberan", role: "Facades lead", team: "Facades London" },
                { name: "Rosario Maguey Peña", role: "Facade designer", team: "Facades London" },
            ],

            mechanical: [
                { name: "Alex Hilton", role: "Lead mechanical engineer", team: "Buildings Engineering London" },
                { name: "Noureddine El Saidi", role: "Mechaincal engineer", team: "Buildings Engineering London" },
                { name: "Zain Ali", role: "Mechanical engineer", team: "Building Engineering London" },
                { name: "Sacha McKenzie", role: "Mechanical technician", team: "Building Engineering London" }
            ],

            CSBT: [
                { name: "George Wright", role: "Lead bridge engineer", team: "Civil Struct Bridges Tunnels London"},
                { name: "Suzanne Evans", role: "Bridge engineer", team: "Civil Struct Bridges Tunnels London"},
                { name: "Ciara Norris", role: "Bridge engineer", team: "Civil Struct Bridges Tunnels London"},
            ],

            civils: [
                { name: "Luis Strengari", role: "Project manager & civil engineer", team:"Civil Engineering London"},
                { name: "Raluca Olariu", role: "Lead civil engineer", team: "Civil Engineering London"},
                { name: "Peter Storey", role: "Civil engineer", team: "Civil Engineering London"},
                { name: "Richie Turner", role: "Civil engineer", team: "Civil Engineering London"},
                {name: "Rhodri Lea", role: "Taxonomy lead", team:"Civil Engineering London"},
            ],

            maritime: [
                { name: "Kyriakos Chomata", role: "Lead maritime engineer", team: "Maritime London"},
                { name: "Isobel McClure", role: "Maritime lead engineer", team: "Maritime London"},
                { name: "Emilio Laiño Rebollido", role: "Maritime engineer", team: "Maritime London"},
            ],

            geotechnics: [
                { name: "Paul Bailie", role: "Lead geotechnical engineer", team: "Geotechnics London"},
                { name: "Louis Andrews", role: "Geotechnical engineer", team: "Geotechnics London"},
            ],
        }
    }
}
</script>